import React, { Component } from 'react';
import "./callIndexSeries.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu';
import config from 'config';
import LibraryApiCall from 'LibraryApiCall';
import ReactHtmlParser from 'react-html-parser';
import SuccessModal from 'LIBRARY/CommonResources/SuccessModal/SuccessModal';
import DeleteModal from 'LIBRARY/CommonResources/DeleteModal/DeleteModal';
import Spinner from 'LIBRARY/CommonResources/SpinnerLoader/Spinner';
import { connect } from 'react-redux';
import SpecificUserLog from 'LIBRARY/CommonResources/SpecificUserLog/SpecificUserLog';

class CallIndexSeries extends Component {


    constructor(props) {
        super(props);
        this.state = {
            departmentList: {},
            callNumberSeriesList: {},
            loadingInstituteList: false,
            hoverId: null,
            deleteModal: false,
            successModal: false,
            selectedCallNumberId: "",
            selectedDepartmentId: "",
            callNumberSeries: [],
            uniqueid: "",

            showActivitySlider: false,
            selectedIid:"",
            hoverID:"",
        };
    }
    
    componentDidMount() {
        // METHOD CALLED TO GET DEPARTMENT LIST
        this.getInstituteStreamsObject();
        this.libraryGetDepartmentWiseCallSeriesList();
    }

    // API CALL METHOD TO GET DEPARTMENT LIST
    getInstituteStreamsObject = async () => {

        this.setState({
            loadingInstituteList: true
        });

        let requestData = {
            "iid": config.institute_id,
            // "limit": this.state.limit,
            // "page_index": this.state.pageIndex,

        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetInstituteStreamsObject',
            requestData,
            '/api/admission/streamManagement.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getInstituteStreamsObject();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;
                this.setState({
                    departmentList: apiResult,
                    loadingInstituteList: false
                });

            }
        }
    }

    // API CALL METHOD TO GET CALL NUMBER SERIES LIST
    libraryGetDepartmentWiseCallSeriesList = async () => {

        let requestData = {
            "iid": config.institute_id,
            "sid": config.stream_id,
            // "limit": this.state.limit,
            // "page_index": this.state.pageIndex,

        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'libraryGetDepartmentWiseCallSeriesList',
            requestData,
            '/api/library/libraryCallNumberSeries.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.libraryGetDepartmentWiseCallSeriesList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let callNumberApiResult = jsonResponse.APIResult.data;
                this.setState({
                    callNumberSeriesList: callNumberApiResult,
                });

            }
        }
    }

    // API CALL METHOD TO ADD CALL NUMBER SERIES
    apiCallToAddCallIndexSeries = async (seriesText, departmentId) => {
        let requestData = {
            "iid": config.institute_id,
            "sid": departmentId,
            "facultyId": config.faculty_id,
            "series_text": seriesText
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'addLibraryCallNumberSeries',
            requestData,
            '/api/library/libraryCallNumberSeries.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToAddCallIndexSeries(seriesText, departmentId)
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                let callNumberSeriesList = this.state.callNumberSeriesList;

                if (apiResult.status == 'success') {
                    if (callNumberSeriesList[apiResult.UID] == undefined) {
                        callNumberSeriesList[apiResult.UID] = {};
                    }

                    callNumberSeriesList[apiResult.UID]['callNumberSeries'] = this.state.callNumberSeries;
                    this.setState({
                        successModal: true,
                        successModalType: 'success',
                        successMessage: ReactHtmlParser(apiResult.message),
                        callNumberSeriesList
                    });
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message,
                    });
                }
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while adding call index series. Please try again later.',
                });
            }
        }
    }

    // API CALL METHOD TO UPDATE CALL NUMBER SERIES
    apiCallToUpdateTemplate = async (value, departmentId, uniqueid) => {

        let requestData = {
            "iid": config.institute_id,
            "sid": departmentId,
            "facultyId": config.faculty_id,
            "series_text": value,
            "unique_id": uniqueid
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'updateLibraryCallNumberSeries',
            requestData,
            '/api/library/libraryCallNumberSeries.php'

        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToUpdateTemplate(value, departmentId, uniqueid)
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;
                // let callNumberSeriesList = this.state.callNumberSeriesList;
                if (apiResult.status == 'success') {
                    this.setState({
                        successModal: true,
                        successModalType: 'success',
                        successMessage: ReactHtmlParser(apiResult.message),
                    });
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message,
                    });
                }
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while updating call index series. Please try again later.',
                });
            }
        }
    }


    // METHOD TO DELETE CALL NUMBER SERIES
    deleteCallNumberSeries = async (departmentId, CallNumberId) => {

        let requestData = {
            "iid": config.institute_id,
            "unique_id_array": [this.state.selectedCallNumberId],
            "facultyId": config.faculty_id
        };
        let jsonResponse = await LibraryApiCall.makeApiCall(
            'deleteLibraryCallNumberSeries',
            requestData,
            '/api/library/libraryCallNumberSeries.php'
        );
        if (jsonResponse.expired) {
            setTimeout(() => {
                this.deleteCallNumberSeries()
            }, 1000);
        } else {
            this.closeDeleteModal();
            if (jsonResponse.success) {

                let apiResult = jsonResponse.APIResult;
                let callNumberSeriesList = this.state.callNumberSeriesList;

                if (apiResult.status == "success") {

                    delete callNumberSeriesList[this.state.selectedDepartmentId];

                    this.setState({
                        successModal: true,
                        successModalType: 'success',
                        successMessage: apiResult.message,
                        callNumberSeriesList
                    });
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message
                    });
                }
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while deleting call index series. Please try again later.'
                });
            }
        }
    }

    // CLOSE DELETE TEMPLATE MODAL
    closeDeleteModal = () => {
        this.setState({
            deleteModal: false
        });
    }

    // METHOD TO CLOSE SUCCESS MODAL
    closeSuccessModal = () => {
        this.setState({
            successModal: false
        });
    }

    // METHOD TO GET CALL NUMBER SERIES
    getCallNumberSeries = (e, id) => {
        // const editAccess=this.props.accessibleOperations['setting'].find(access => access === 'edit');

        // if(editAccess !== undefined){

            let callNumberSeriesList = this.state.callNumberSeriesList;
            if (callNumberSeriesList[id] != undefined) {
                callNumberSeriesList[id].series_text = e.target.value;
            }
            else {
                callNumberSeriesList[id] = {};
                callNumberSeriesList[id].series_text = e.target.value;
                callNumberSeriesList[id].unique_id = "";
                callNumberSeriesList[id].added_by = "";
                callNumberSeriesList[id].added_on = "";
                callNumberSeriesList[id].updated_by = "";
                callNumberSeriesList[id].updated_on = "";
                callNumberSeriesList[id].iid = config.institute_id;
                callNumberSeriesList[id].sid = id;
            }

            this.setState({
                callNumberSeries: e.target.value,
                selectedDepartmentId: id,
                callNumberSeriesList
            });
        // }
        // else
        // {
        //     this.setState({
        //         successModal: true,
        //         successModalType: 'warning',
        //         successMessage: 'This operation is restricted by the Library admin.'
        //     });
        // }
    }

    // METHOD TO SAVE CALL NUMBER SERIES
    saveCallNumberSeries = (departmentId, unique_id, seriesText) => {
        const editAccess= this.props.isAdmin == true ? true : this.props.accessibleOperations['setting'].find(access => access === 'edit');

        if(editAccess !== undefined){
            const value = seriesText;
            const selectedDepartmentId = this.state.selectedDepartmentId;
            this.setState({
                uniqueid: unique_id,
            });

            if (unique_id == undefined || unique_id == '') {
                this.apiCallToAddCallIndexSeries(value, departmentId);
            } else {
                this.apiCallToUpdateTemplate(value, departmentId, unique_id)
            }
        }
        else
        {
            this.setState({
                successModal: true,
                successModalType: 'warning',
                successMessage: 'This operation is restricted by the Library admin.'
            });
        }  
    }

    // METHOD TO CHECK ACCESS FOR DELETE OPERATION
    checkDeleteAccess = () => {

        const deleteAccess = this.props.isAdmin == true ? true : this.props.accessibleOperations['setting'].find(access => access === 'delete');

        if(deleteAccess !== undefined){
            this.setState({
                deleteModal: true,
            });
        }
        else
        {
            this.setState({
                successModal: true,
                successModalType: 'warning',
                successMessage: 'This operation is restricted by the Library admin.'
            });
        }
    }

    openActivitySlider = (id) => {
        this.setState({
            selectedIid: id,
            showActivitySlider: true
        });
    };

    closeActivitySlider = () => {
        this.setState({
            selectedIid: "",
            showActivitySlider: false
        });
    };

    render() {

        return (
            <>
                <RoutingMenu activeScreen="callIndexSeries" />

                <div className="libraryComponents-container">
                    <div className=" row col-md-12">
                        <button className="btn closeDetails" title="Click to visit back to library settings" style={{ marginRight: '10px' }} onClick={() => this.props.closeCallIndexSeries()} >
                            <FontAwesomeIcon className="" icon={["fa", "angle-left"]} />
                        </button>
                        &nbsp;
                        <div className="mt-1">
                            <h3 style={{ fontSize: "28px" }}>Call Index Series</h3>
                        </div>
                    </div>
                    {
                        this.state.loadingInstituteList ?
                            <Spinner />
                            :
                            <div className=" mt-3 col-md-12">
                                <table class="table table-bordered mb-0">
                                    <thead>
                                        <tr>
                                            <th style={{fontWeight:'bold'}}>Department</th>
                                            <th style={{fontWeight:'bold'}}>Call Index series</th>
                                            <th style={{fontWeight:'bold'}}>Last Modified By</th>
                                            <th style={{fontWeight:'bold'}}>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            Object.keys(this.state.departmentList).map((departmentId) => {
                                                let department = this.state.departmentList[departmentId] != undefined ? this.state.departmentList[departmentId] : '';
                                                let selectedSeriesObject = this.state.callNumberSeriesList[departmentId] != undefined ? this.state.callNumberSeriesList[departmentId] : '';
                                                return (
                                                    <>
                                                        <tr onMouseEnter={(e) => this.setState({ hoverId: departmentId })}>
                                                            <th className="tableRow">{department.stream_name}</th>
                                                            <td className="tableRow">
                                                                <input
                                                                    type='text' className='form-control pl-2'
                                                                    style={{ color: 'black', fontSize: '14px' }}
                                                                    placeholder='Enter Call Index Series'
                                                                    value={Object.keys(selectedSeriesObject).length > 0 ? selectedSeriesObject.series_text : ""}
                                                                    maxLength={25}
                                                                    onChange={(e) => this.getCallNumberSeries(e, departmentId)}
                                                                />
                                                            </td>
                                                            <td className="table-rows vm_custom_body5" style={{ border: '1.01px solid #E0E8EF', padding: "5px", cursor: "pointer", color: departmentId == this.state.hoverID ? "#0465AC" : "" }}
                                                                onMouseEnter={() => this.setState({ hoverID: departmentId })}
                                                                onMouseLeave={() => this.setState({ hoverID: "" })}
                                                                onClick={() => this.openActivitySlider(departmentId)}>
                                                                {selectedSeriesObject.updated_by_Name ? (
                                                                    <div className="d-flex flex-column">
                                                                        <div>{selectedSeriesObject.updated_by_Name} ({selectedSeriesObject.last_updated_by_ERP}) | {selectedSeriesObject.updatedOn}</div>
                                                                    </div>
                                                                ) : (
                                                                    <div className="d-flex flex-column">
                                                                        <div>{selectedSeriesObject.added_by_name} ({selectedSeriesObject.added_by_ERP}) | {selectedSeriesObject.addedOn}</div>
                                                                    </div>
                                                                )}
                                                            </td>
                                                            <td className="tableRow text-center">
                                                                {this.state.hoverId === departmentId && (

                                                                    <div className="text-left">
                                                                        <FontAwesomeIcon
                                                                            style={{ cursor: 'pointer' }}
                                                                            size='lg'
                                                                            icon={["fa", "save"]}
                                                                            title="Click here to save"
                                                                            onClick={() => this.saveCallNumberSeries(departmentId, selectedSeriesObject.unique_id, selectedSeriesObject.series_text)}
                                                                        />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                                                        <FontAwesomeIcon
                                                                            style={{ cursor: 'pointer' }}
                                                                            size='lg'
                                                                            icon={["fa", "times"]}
                                                                            title="Click here to delete"
                                                                            onClick={() => this.setState({selectedDepartmentId: departmentId, selectedCallNumberId: selectedSeriesObject.unique_id },() => this.checkDeleteAccess())}
                                                                        />
                                                                    </div>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    </>
                                                )
                                            })

                                        }

                                    </tbody>
                                </table>
                            </div>

                    }

                    {
                        this.state.successModal &&
                        <SuccessModal
                            successModal={this.state.successModal}
                            successModalType={this.state.successModalType}
                            successMessage={this.state.successMessage}
                            closeSuccessModal={this.closeSuccessModal}
                        />
                    }
                    {
                        this.state.deleteModal &&
                        <DeleteModal
                            showModal={this.state.deleteModal}
                            visibility={this.closeDeleteModal}
                            deleteKey='Call Index Series'
                            deleteComponent={this.deleteCallNumberSeries}
                        />
                    }
                    {
                        this.state.showActivitySlider && this.state.selectedIid != "" &&
                        <SpecificUserLog
                            showSlider={this.state.showActivitySlider}
                            closeSlider={this.closeActivitySlider}
                            logUid={this.state.selectedIid}
                            activityArr={['CallIndexSeries_added']}
                        />
                    }
                </div>
            </>
        )
    }
}

const mapStateToProps = store => {
    return {
        // VARIABLES TO GET AGENCY DETAILS
        accessibleOperations:store.RouteMenuReducer.accessibleOperations,
        isAdmin:store.RouteMenuReducer.isLibraryAdmin
    };
};

export default connect(mapStateToProps)(CallIndexSeries);
